﻿import Common from './i247.Common.js';

class Address {
    constructor () {
        this.ElementID = null;
    }

    // Built to only have one address visible on the page at once
    // Call setup after you make your address visible to the user
    Setup (AddressListElementID, UniqueReference, LogDescription) {
        let _this = this;
        let container = new ContainingElement(UniqueReference);
        var $buttonSelector = $('#' + container.ElementID + 'ButtonPostCodeLookup');
        $buttonSelector.unbind('click');
        $buttonSelector.click(function () {
            _this.Search(AddressListElementID, LogDescription, container.ElementID);
        });
        $buttonSelector.trigger('click');
    }

    GetAddressList (PostCode, RequestVerificationToken, Logdescription) {
        var result = $.Deferred();

        $.ajax({
            url: '/address/addresslist',
            type: 'POST',
            data: {
                postcode: PostCode,
                __RequestVerificationToken: RequestVerificationToken,
                LogDescription: Logdescription
            },

            cache: true,

            success: function (data) {
                result.resolve(data);
            },

            error: function (xhr, ajaxOptions, thrownError) {},

            complete: function (data) {}
        });

        return result.promise();
    }

    GetCoordinates (postcode, requestVerificationToken, logDescription) {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: '/address/coordinates',
                type: 'POST',
                data: {
                    postcode: postcode,
                    __RequestVerificationToken: requestVerificationToken,
                    logDescription: logDescription
                },
                cache: true,
                success: function (data) {
                    resolve(data);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    reject(thrownError);
                },
                complete: function (data) {}
            });
        });
    }

    GetPostCodeAddress (Key, RequestVerificationToken, VehicleRegistration) {
        var result = $.Deferred();

        $.ajax({
            url: '/address/PostCodeAddress',
            type: 'POST',
            data: {
                key: Key,
                __RequestVerificationToken: RequestVerificationToken,
                vehicleRegistration: VehicleRegistration
            },
            cache: true,
            success: function (data) {
                result.resolve(data);
            },
            error: function (xhr, ajaxOptions, thrownError) {},
            complete: function (data) {}
        });

        return result.promise();
    }

    Search (addressListElementID, logDescription, containerElementID) {
        let _this = this;
        var addressHTML = '';
        var postcode = $('#' + containerElementID + 'Postcode').val().toLocaleUpperCase();
        $('#' + containerElementID + 'Postcode').val(postcode);

        if (!postcode) {
            $('#' + containerElementID + 'Postcode').addClass('k-invalid');
            return;
        } else {
            $('#' + containerElementID + 'Postcode').removeClass('k-invalid');
        }

        var addresses = this.GetAddressList(postcode, $('input[name=__RequestVerificationToken]').val(), logDescription);
        $.when(addresses).done(function (l_addresses) {
            if (l_addresses.length > 0) {
                addressHTML += '<ul class="pl-0" style="list-style-type:none;">';
                $.each(l_addresses, function (Id, address) {
                    var displayText = '';
                    if (address.property.length > 0) displayText = address.property + ', ';
                    if (address.organisation.length > 0) displayText += address.organisation + ', ';
                    if (address.street.length > 0) displayText += address.street + ', ';
                    if (address.town.length > 0) displayText += address.town;
                    addressHTML += '<li><a href="#" class=\"address-list-item\" data-organisation=\"' + address.organisation + '\" data-property=\"' + address.property + '\" data-street=\"' + address.street + '\" data-locality=\"' + address.locality + '\" data-town=\"' + address.town + '\" data-postalcounty=\"' + address.postalCounty + '\" data-postcode=\"' + address.postcode + '\"><span class=\"fas fa-home\" style=\"margin-right:10px;\"></span>' + displayText + '</li>';
                });
                addressHTML += '</ul>';
			} else {
				addressHTML += "<p>We're sorry but we cannot find the postcode <strong>" + postcode + "</strong>. If that is the correct postcode, please call your driverline for further assistance.</p>";
                addressHTML += '<div class="form-group row mt-3" >' +
					'<div class="col-md-10">' +
					'<button class="btn btn-outline-dark" style="width:280px;">Go Back</button>' +
					'</div>' +
					'</div>';
            }

            $('#' + containerElementID + 'AddressList')
                .html('')
                .html(addressHTML)
                .css('height', $('#' + containerElementID).height() + 'px');

            $('#' + containerElementID + 'AddressList').find('.address-list-item').each(function (index, element) {
                $(element).on('click', function (event) {
                    event.preventDefault();
                    _this.PopulateAddress(this, addressListElementID, containerElementID);
                });
            });

            $('#' + containerElementID + 'AddressList').find('.btn-outline-dark').each(function (index, element) {
                $(element).on('click', function () {
                    _this.SlideBack(containerElementID);
                });
            });

            $('#' + containerElementID).animate({
                marginLeft: '-1500px'
            }, 500, function () {
                $('#' + containerElementID + 'AddressList').animate({
                    marginRight: '0px'
                }, 500, function () {
                    // Animation complete.
                });
            });
        });
    }

    PopulateAddress (addressElement, addressListElementID, containerElement) {
        this.SlideBack(containerElement);
        let street = $(addressElement).data('property') ? `${$(addressElement).data('property')}, ${$(addressElement).data('street')}` : $(addressElement).data('street');
        let address = {
            addressLine1Input: $('#' + containerElement).find('#' + containerElement + 'Address_AddressLine1'),
            addressLine2Input: $('#' + containerElement).find('#' + containerElement + 'Address_AddressLine2'),
            addressTown: $('#' + containerElement).find('#' + containerElement + 'Address_Town'),
            addressCounty: $('#' + containerElement).find('#' + containerElement + 'Address_County'),
            addressPostCode: $('#' + containerElement).find('#' + containerElement + 'Postcode')
        };

        for (let prop in address) {
            $(address[prop]).val('');
            Common.RemoveValidationStyles(address[prop]);
        }

        if ($(addressElement).data('organisation')) {
            address.addressLine1Input.val($(addressElement).data('organisation'));
            address.addressLine2Input.val(street);
        } else {
            address.addressLine1Input.val(street);
        }

        address.addressTown.val($(addressElement).data('town'));
        address.addressCounty.val($(addressElement).data('postalcounty'));
        address.addressPostCode.val($(addressElement).data('postcode'));
    }

    BindControls () {
        let _this = this;
        $('.buttonPostCodeLookup').on('click', function () {
            var containerId = $(this).parents('.addressContainer').prop('id').replace(' ', '');
            _this.Search('PostCodeLookupDialog', '', containerId);
        });
    }

    SlideBack (containerElement) {
        $('#' + containerElement + 'AddressList').animate({
            marginRight: '-1500px'
        }, 500, function () {
            $('#' + containerElement).animate({
                marginLeft: '0px'
            }, 500, function () {
                $('#' + containerElement + 'AddressList').html('');
            });
        });
    }        

    ContainingElement (elementID) {
        this.ElementID = elementID;
    }
}

export let _address = new Address();
